import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FechaTrasladoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='F. INICIO TRASLADO' htmlFor='date-fechaTraslado' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='fechaTraslado'>
          {({ field }) => (
            <Form.InputDate
              {...field}
              id='date-fechaTraslado'
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaTrasladoFormGroup)
